import { render, staticRenderFns } from "./CustomFields.vue?vue&type=template&id=1ab32810&"
import script from "./CustomFields.vue?vue&type=script&lang=ts&"
export * from "./CustomFields.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports